import { createFileRoute } from "@tanstack/react-router";

import { Contact } from "@/features/site/modules/contact/contact";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/$trainerSlug/contact/")({
  component: ContactPage,
  loader: () => ({ crumb: m.landing_nav_contact() }),
});

function ContactPage() {
  return <Contact />;
}
